import tavel from "../images/speakers/tavel.png";
import img1 from "../images/investors/img1.jpg";
import img2 from "../images/investors/img2.png";
import img3 from "../images/investors/img3.png";
import img4 from "../images/investors/img4.png";
import img5 from "../images/investors/img5.png";
import img7 from "../images/investors/img7.png";
import img8 from "../images/investors/img8.png";
import img9 from "../images/investors/img9.png";
import img6 from "../images/investors/img6.jpg";
import img10 from "../images/investors/img10.jpg";
import img18 from "../images/investors/img18.jpg";
import img11 from "../images/investors/img11.png";
import img12 from "../images/investors/img12.png";
import img13 from "../images/investors/img13.png";
import img14 from "../images/investors/img14.png";
import img15 from "../images/investors/img15.png";
import img16 from "../images/investors/img16.png";
import img17 from "../images/investors/img17.png";
import img19 from "../images/investors/img19.png";
import img20 from "../images/investors/img20.png";
import img21 from "../images/investors/img21.png";
import img22 from "../images/investors/img22.png";
import img23 from "../images/investors/img23.png";

import "../styles/Speaker2Investor.css";

const Speaker2Investor = () => {
  return (
    <div className="container">
      <h2  className="textSize" style={{ color: "blue" }}>MEET OUR 2023 INVESTORS</h2>
      <div className="inner-container">
        <table>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img1} />
                <p className="image-text">
                  Hans Tung <br />
                  Managing Partner <br />
                  GGV Capital{" "}
                </p>
              </div>
            </td>

            <td>
              <div className="image">
                <img className="image-contain" src={img2} />
                <p className="image-text">
                  Rebecca Kaden <br />
                  General Partner <br />
                  Union Square Ventures{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img3} />
                <p className="image-text">
                  Anish Acharya <br />
                  General Partner <br />
                  Andreessen Horowitz
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img4} />
                <p className="image-text">
                  Sarah Tavel <br />
                  General Partner <br />
                  Benchmark{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img5} />
                <p className="image-text">
                  Nigel Morris <br />
                  Co-Founder and General Partner <br />
                  QED Investors{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img6} />
                <p className="image-text">
                  Rebecca Lynn <br />
                  General Partner <br />
                  Canvas Ventures{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img7} />
                <p className="image-text">
                  Shardul Shah <br />
                  Partner <br />
                  Index Ventures
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img8} />
                <p className="image-text">
                  Elad Gil
                  <br />
                  Investor <br />
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img9} />
                <p className="image-text">
                  Ansaf Kareem
                  <br />
                  Founder <br />
                  Latitude Capital
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img10} />
                <p className="image-text">
                  Kanu Gulati
                  <br />
                  Partner <br />
                  Khosla Ventures
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img11} />
                <p className="image-text">
                  Kevin Colleran <br />
                  Co-founder &amp; Managing Director
                  <br />
                  Slow Ventures
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img12} />
                <p className="image-text">
                  Eurie Kim
                  <br />
                  Managing Partner <br />
                  Forerunner
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img13} />
                <p className="image-text">
                  Lonne Jaffe
                  <br />
                  Managing Director <br />
                  Insight Partners
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img14} />
                <p className="image-text">
                  Beth Ferreira <br />
                  General Partner
                  <br />
                  FirstMark
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img15} />
                <p className="image-text">
                  Michael Yang
                  <br />
                  Managing Partner <br />
                  OMERS Ventures
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img16} />
                <p className="image-text">
                  Christine Tsai <br />
                  Founding Partner &amp; CEO
                  <br />
                  500 Global
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={tavel} />
                <p className="image-text">
                  Kobie Fuller
                  <br />
                  General Partner <br />
                  Upfront Ventures
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img17} />
                <p className="image-text">
                  Kathryn Wortsman <br />
                  CEO
                  <br />
                  Amplify Capital
                </p>
              </div>
            </td>
          </tr>{" "}
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img18} />
                <p className="image-text">
                  Seth Bannon
                  <br />
                  Founding Partner <br />
                  Fifty Years
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img19} />
                <p className="image-text">
                  Brett Gibson
                  <br />
                  Managing Partner
                  <br />
                  Initialized Capital{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img20} />
                <p className="image-text">
                  Alanna Souza
                  <br />
                  General Manager <br />
                  Drive Capital
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img21} />
                <p className="image-text">
                  Roy Bahat
                  <br />
                  Head
                  <br />
                  Bloomberg Beta{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={img22} />
                <p className="image-text">
                  Eva Ho
                  <br />
                  General Partner
                  <br />
                  Fika Ventures
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={img23} />
                <p className="image-text">
                  Lu Zhang
                  <br />
                  Founder &amp; Managing Partner
                  <br />
                  Fusion Fund{" "}
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};
export default Speaker2Investor;
